const RadioUnselectedIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="18" viewBox="0 0 17 18" fill="none">
      <circle cx="8.5" cy="9" r="8" fill="white" stroke="#002035" />
    </svg>
  );
};

export default RadioUnselectedIcon;
